<template>
	<div class="container-fluid">
		<div class="row row-sorting-wrapper">
			<div
				class="sorting-item-column sorting-item-column-4"
				v-for="(item, index) of Object.entries(sortingData)"
				:key="index"
			>
				<FootprintTableSortingSingle
					:data="item"
				/>
			</div>
		</div>
	</div>
</template>

<script>
import FootprintTableSortingSingle from './FootprintTableSortingSingle'

export default {
	props: ['sortingData'],
	name: "FootprintTableSorting",
	components: {
		FootprintTableSortingSingle
	}
}
</script>

<style scoped>

</style>